import { connect } from 'react-redux';
import DanglingDNSRecordsCountRecipe from './components/DanglingDNSRecordsCountRecipe';
import {
  loadScoreDetails,
  loadMergeAPIIPDetails,
  loadMergeAPIDomainDetails,
  loadMergeAPIExploreDetails,
  loadMergeAPIExploreDensity,
  loadDanglingDNSRecordsCountData,
  saveMergeAPIExploreRecipeDanglingDNSRecordsCount,
  loadMergeAPIExploreRecipeDanglingDNSRecordsCount,
  deleteMergeAPIExploreRecipeDanglingDNSRecordsCount,
  updateMergeAPIExploreRecipeDanglingDNSRecordsCount,
  changeScopeMergeAPIExploreRecipeDanglingDNSRecordsCount,
  resetRecipeStatus,
  clearExploreDetails,
  cloneRecipe,
  unsetClearRecipe,
} from '../../redux/actions/ioc';
import { loadUser, loadMySubscriptionPlan } from '../../redux/actions/user';

const mapStateToProps = (state) => ({
  status: state.ioc.detailsStatus,
  scoreDetails: state.ioc.scoreDetails,
  mergeAPIscoreDetails: state.ioc.mergeAPIscoreDetails,
  exploreAPIscoreDetails: state.ioc.exploreAPIscoreDetails,
  exploreAPIDensityDetails: state.ioc.exploreAPIDensityDetails,

  //this status is the recipe itself
  recipeStatusDanglingDNSRecordsCount:
    state.ioc.recipeStatusDanglingDNSRecordsCount,
  exploreRecipeDanglingDNSRecordsCount:
    state.ioc.exploreRecipeDanglingDNSRecordsCount,

  //this one is the results for the modal
  recipeDataStatusDanglingDNSRecordsCount:
    state.ioc.recipeDataStatusDanglingDNSRecordsCount,
  exploreRecipeDataDanglingDNSRecordsCount:
    state.ioc.exploreRecipeDataDanglingDNSRecordsCount,

  exploreRecipe: state.ioc.exploreRecipe,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
  clearRecipe: state.ioc.clearRecipe,
});

const mapDispatchToProps = {
  loadUser,
  loadScoreDetails,
  resetRecipeStatus,

  loadDanglingDNSRecordsCountData,
  saveMergeAPIExploreRecipeDanglingDNSRecordsCount,
  loadMergeAPIExploreRecipeDanglingDNSRecordsCount,
  updateMergeAPIExploreRecipeDanglingDNSRecordsCount,
  deleteMergeAPIExploreRecipeDanglingDNSRecordsCount,
  changeScopeMergeAPIExploreRecipeDanglingDNSRecordsCount,

  loadMergeAPIIPDetails,
  loadMergeAPIDomainDetails,
  loadMergeAPIExploreDetails,
  loadMergeAPIExploreDensity,
  clearExploreDetails,
  cloneRecipe,
  loadMySubscriptionPlan,
  unsetClearRecipe,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DanglingDNSRecordsCountRecipe);
